export type CommerceCreationGuard = {
  inFlight: boolean;
  completed: boolean;
};

export const createCommerceOnce = async (
  guard: CommerceCreationGuard,
  create: () => Promise<unknown>
): Promise<boolean> => {
  if (guard.inFlight || guard.completed) return false;

  guard.inFlight = true;
  try {
    await create();
    guard.completed = true;
    return true;
  } finally {
    guard.inFlight = false;
  }
};
